import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import logo from "../assets/Logo.png"; // dein Logo in assets speichern


const Home = () => {
  const domains = [
    {
      name: "scratchify.de",
      price: "€599",
      link: "https://www.afternic.com/forsale/scratchify.de",
    },
    {
      name: "pet-ventures.de",
      price: "€299",
      link: "https://www.afternic.com/forsale/pet-ventures.de",
    },
    {
      name: "aurelio.co",
      price: "make offer",
      link: "https://domvault.de",
    },
    {
      name: "zodos.eu",
      price: "make offer",
      link: "https://domvault.de",
    },
    {
      name: "grynt.eu",
      price: "not 4 sale",
      link: "https://grynt.eu",
    },
    {
      name: "domvault.de",
      price: "not 4 sale",
      link: "https://domvault.de",
    },
  ];

  return (
    <div className="home-container">
      {/* ======= HERO ======= */}
      <section className="hero-section text-center">
        <img src={logo} alt="DomVault Logo" className="hero-logo" />
        <p className="hero-subtitle">The Vault for Valuable Names.</p>
        <p className="hero-text">
          We collect, hold, and sell premium domains for the digital age.
        </p>
      </section>

      {/* ======= DOMAINS ======= */}
      <section className="domains-section text-center">
        <h2 className="section-title">Available Domains</h2>
        <Container>
          <Row className="justify-content-center">
            {domains.map((d, index) => (
              <Col key={index} xs={12} sm={6} md={4} className="mb-4">
                <Card className="domain-card">
                  <Card.Body>
                    <Card.Title className="domain-name">{d.name}</Card.Title>
                    <Card.Text className="domain-price">{d.price}</Card.Text>
                    <Button
                      href={d.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="buy-btn"
                    >
                      View Listing
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <p className="domain-note">Verkauf und Abwicklung erfolgen über GoDaddy / Afternic.</p>
          <p className="domain-note">Sale and transaction handled securely via GoDaddy / Afternic.</p>

        </Container>
      </section>

      {/* ======= ABOUT ======= */}
      <section className="about-section text-center">
        <h2 className="section-title">About DomVault</h2>
        <p className="about-text">
          DomVault is a private digital asset vault specializing in premium
          domain acquisition and sales. Each domain is hand-selected for it´s
          brand potential, SEO value and uniqueness. Secure your next digital
          property with confidence.
        </p>
      </section>

      {/* ======= FOOTER ======= */}
      <footer className="footer text-center">
        <p>© 2025 DomVault – The Vault for Valuable Names.</p>
        <p>
          <a href="/impressum" className="footer-link">Impressum</a> |{" "}
          <a href="/contact" className="footer-link">Contact</a> |{" "}
          <a href="/datenschutz" className="footer-link">Privacy Policy</a>
        </p>
      </footer>
    </div>
  );
};


export default Home;